import { Close as CloseIcon } from '@material-ui/icons';
import cx from 'classnames';
import { FC, useCallback, useState } from 'react';
import { Navigation } from 'swiper';
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { Button } from '@shared/components/button';
import { Dialog, DialogTheme } from '@shared/components/dialog';
import { IImageDetails } from '@shared/models/IImages';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { styles } from './Carousel.styles';
import './carouser.styles.scss';

export interface CarouselProps extends WithStyles<typeof styles> {
  images: IImageDetails[];
  withGallery?: boolean;
}

const CarouselComponent: FC<CarouselProps> = ({ classes, images, withGallery = false }) => {
  const [openGallery, setOpenGallery] = useState(false);

  const renderImages = useCallback(
    (dialog?: boolean) => {
      return images.map((image, idx) => (
        <SwiperSlide key={`image-${image.id}-${idx}`}>
          <img src={image.url} className={cx(classes.image, { [classes.fullImage]: dialog })} alt="" />
        </SwiperSlide>
      ));
    },
    [images, openGallery]
  );

  const carousel = useCallback(
    (dialog?: boolean) => {
      return (
        <Swiper
          pagination={{
            clickable: true,
            clickableClass: cx(classes.pagination, { [classes.paginationGallery]: withGallery }),
          }}
          navigation={true}
          modules={[Navigation, Pagination]}
        >
          {!!images.length && renderImages(dialog)}
        </Swiper>
      );
    },
    [withGallery, images, renderImages]
  );

  const handleCloseGallery = () => {
    setOpenGallery(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.previewCarousel}>{carousel()}</div>
      {withGallery && (
        <div className={classes.gallery} onClick={() => setOpenGallery(true)}>
          <i className={`icon icon-image ${classes.galleryImage}`} />
          <span className={classes.galleryLabel}>Gallery</span>
        </div>
      )}
      <Dialog
        classes={{ root: classes.dialog }}
        open={openGallery}
        theme={DialogTheme.legacy}
        withFooter={false}
        withTransition
        onClose={handleCloseGallery}
      >
        {carousel(true)}
        <Button
          variant="outlined"
          size="small"
          color="default"
          text={<CloseIcon className={classes.headerIcon} />}
          onClick={handleCloseGallery}
          classes={{
            root: classes.headerBtn,
            outlinedSizeSmall: classes.headerBtnSmall,
          }}
        />
      </Dialog>
    </div>
  );
};

export const Carousel = withStyles(styles)(CarouselComponent);
